import { TypographyOptions } from '@mui/material/styles/createTypography';

import { FavoritPro, Matter } from '@/styles/fonts';

export const typography: TypographyOptions = {
  fontFamily: FavoritPro.style.fontFamily,
  h1: {
    fontFamily: Matter.style.fontFamily,
    fontWeight: 600,
    fontSize: '32px',
    lineHeight: '35px'
  },
  h2: {
    fontFamily: Matter.style.fontFamily,
    fontWeight: 600,
    fontSize: '22px',
    lineHeight: '24px'
  },
  body1: {
    fontFamily: FavoritPro.style.fontFamily,
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '21px'
  },
  body2: {
    fontFamily: FavoritPro.style.fontFamily,
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '21px'
  },
  caption: {
    fontFamily: FavoritPro.style.fontFamily,
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px'
  }
};
